import requestModule from '../libs/requestModule'
import CartController from '../controllers/CartController'
import Util from '@/assets/libs/util.js'

const TOKEN_AUTH = 'Bearer 3HSecj3d4xw3he0376d8dpjU0Tk8Ew89xwgkJF303jceo3GW902jUdW3gdc8eEbdKB67312ls'

const getApiUrl = () => {
    const fixeCrm = Util.getLocalConfigs('fixeCrm')
    return fixeCrm && fixeCrm.url ? fixeCrm.url : null
}

const apiHeaders = {
    Authorization: TOKEN_AUTH,
    'Content-Type': 'application/xml'
}
const POINTS = () => getApiUrl() + '/pointsv2'
const ADD_POINTS = () => getApiUrl() + '/transaction/addPoints'
const REMOVE_POINTS = () => getApiUrl() + '/transaction/removePoints'
const CANCEL_POINTS = () => getApiUrl() + '/transaction/cancelPoints'

const generalInfo = Util.getGeneralInfo() || {}

let clientInfo = {}
let valueAvailable = 0
let cashbackValue = 0
let documentNumber = ''
let productName = ''
let maxStamps = 0
let couponValue = 0
let customerPoints = 0
let hasFidelity = false
let saleDataInfo = null

/*
    Checa o status da campanha de fidelidade do Fixe CRM, verificando se a API está acessível e se os parâmetros necessários estão configurados.
    Deve ser chamada no início do processo de checkout para validar se a campanha pode ser aplicada. Retorna true se a campanha estiver ativa e configurada corretamente, ou false caso contrário.
*/
const checkStatus = async function () {
    const apiUrl = getApiUrl()
    if (!apiUrl) {
        return false
    }
    let hasAllParams = true
    Object.keys(apiHeaders).forEach(e => {
        if (!apiHeaders[e]) hasAllParams = false
    })
    if (!hasAllParams) {
        return false
    }
    return true
}

/*
    Consulta as informações do cliente na API do Fixe CRM, utilizando o número do documento (CPF/CNPJ) como identificador.
*/
const getClientInfo = async function (docNumber) { // CHECA SE O CLIENTE TEM CUPOM DISPONÍVEL NA CARTEIRA
    const sanitized = docNumber ? docNumber.replace(/\D/g, '') : ''
    if (!sanitized) {
        return { success: false, reason: null }
    }

    documentNumber = sanitized
    const params = {
        root: {
            uniqueId: documentNumber
        }
    }
    let result = await requestModule.xmlRequest(POINTS(), 'post', params, apiHeaders)
    result = formatResult(result)

    if (!result || !result.root) {
        return { success: false, reason: null }
    }

    if (result.root.error && result.root.error !== 'false') {
        const message = result.root.message || 'Cliente não tem fidelidade'
        return { success: false, reason: 'NO_FIDELITY', message }
    }

    clientInfo = result.root
    hasFidelity = true

    maxStamps = Number(clientInfo.maxStamps) || 0
    customerPoints = Number(clientInfo.points) || 0
    couponValue = Number(clientInfo.discounts && clientInfo.discounts.data && clientInfo.discounts.data.value) || 0

    if (customerPoints < maxStamps || maxStamps === 0) {
        return { success: false, reason: 'NO_POINTS', message: 'Cliente não possui pontos suficientes, mas ainda acumula pontos' }
    }

    if (couponValue > 0) {
        valueAvailable = couponValue
        productName = (clientInfo.products && clientInfo.products.data && clientInfo.products.data.name) || ''
    }

    return { success: true, data: clientInfo }
}

/*
    Função para construir o payload da transação, utilizada tanto para adicionar pontos (addPoints) quanto para remover pontos (removePoints) e cancelar pontos (cancelPoints)
*/
function buildTransactionPayload (saleData, discount = 0) {
    let value = 0

    if (discount > 0) {
        value = discount
    } else {
        value = Number(CartController.getTotalPriceAsFloat(false, false) || 0).toFixed(2)
    }

    const cartItems = CartController.getCart()
    const details = cartItems.map(item => ({
        prod: {
            sku: item.productCode || '',
            name: item.productName || saleData.storeName,
            count: item.quantity || 1
        }
    }))

    let params = {
        root: {
            uniqueId: documentNumber,
            value: value,
            source: saleData.storeName || 'TAA',
            location: generalInfo.subsidiaryCode + saleData.storeCode,
            externalId: saleData.saleSeq,
            details: details,
            is_delivery: false
        }
    }
    return params
}

/*
    Realiza a remoção dos pontos do cliente na API do Fixe CRM, utilizando o número do documento e os dados da venda para construir o payload da transação.
*/
const redeemPoints = async function (saleData, discount) {
    const params = buildTransactionPayload(saleData, discount)

    let result = await requestModule.xmlRequest(REMOVE_POINTS(), 'post', params, apiHeaders)
    result = formatResult(result)

    if (!isValidTransactionResponse(result)) {
        Util.showInfoModal('Falha ao gerar cashback. <br> A venda será cancelada.')
        throw new Error('Falha na rotina removePoints')
    }

    const log = result.root.log
    cashbackValue = Number(log.amount) || 0
    return log
}

/*
    Realiza a adição dos pontos do cliente na API do Fixe CRM, utilizando o número do documento e os dados da venda para construir o payload da transação.
*/
const makeSale = async function (saleData) {
    const params = buildTransactionPayload(saleData)
    const result = await requestModule.xmlRequest(ADD_POINTS(), 'post', params, apiHeaders)
    const formatted = formatResult(result)
    if (!isValidTransactionResponse(formatted)) {
        const status = formatted && formatted.root && formatted.root.status
        if (status === '105') {
            return { ignored: true }
        }
        return null
    }
    return formatted.root.log
}

/*
    Realiza o cancelamento da transação de pontos do cliente na API do Fixe CRM, utilizando o número do documento e os dados da venda para construir o payload da transação.
    Deve ser chamada em casos de estorno ou cancelamento da venda para garantir que os pontos sejam revertidos corretamente.
*/
const chargebackSale = async function () {
    if (!saleDataInfo) return null
    const params = buildTransactionPayload(saleDataInfo)

    const result = await requestModule.xmlRequest(CANCEL_POINTS(), 'post', params, apiHeaders)
    const formatted = formatResult(result)
    if (!isValidTransactionResponse(formatted)) {
        return null
    }
    return formatted.root.log
}

/*
    Função auxiliar para formatar a resposta da API do Fixe CRM, extraindo os campos de texto dos objetos XML e retornando um objeto JavaScript mais simples.
    Recebe a resposta bruta da API e tenta extrair os campos de texto dos objetos XML, retornando um objeto JavaScript mais fácil de manipular. Em caso de erro durante o processo de formatação, retorna null.
*/
function formatResult (result) {
    if (!result) {
        return null
    }
    try {
        return Util.flattenXmlTextFields(result)
    } catch (error) {
        return null
    }
}

// Valida resposta das rotas de transação (removePoints, addPoints, cancelPoints)
// que retornam root.log + root.status
function isValidTransactionResponse (result) {
    if (!result || !result.root) {
        return false
    }
    if (result.root.error && result.root.error !== 'false') {
        return false
    }
    if (result.root.status && result.root.status !== 'ok') {
        return false
    }
    return !!result.root.log
}

export default {
    checkStatus,
    chargebackSale,
    redeemPoints,
    makeSale,
    clearData: () => {
        documentNumber = ''
        cashbackValue = 0
        valueAvailable = 0
        clientInfo = {}
        maxStamps = 0
        couponValue = 0
        customerPoints = 0
        hasFidelity = false
        saleDataInfo = null
    },
    getHasFidelity: () => hasFidelity,
    getClientInfo,
    getClientData: () => {
        return clientInfo
    },
    getCashbackValue: () => {
        return cashbackValue
    },
    setCashbackValue: (value) => {
        cashbackValue = value
    },
    setSaleData: (saleData) => {
        saleDataInfo = saleData
    },
    getResume: () => {
        const couponsUsed = couponValue > 0 ? Math.ceil(cashbackValue / couponValue) : 0
        const pointsUsed = couponsUsed * maxStamps
        const remainingPoints = customerPoints - pointsUsed
        return {
            campaignEnabled: 5,
            cashbackValue: cashbackValue,
            valueAvailable: valueAvailable,
            productName: productName,
            couponsUsed: couponsUsed,
            pointsUsed: pointsUsed,
            remainingPoints: remainingPoints,
            couponValue: couponValue
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/controllers/CampaignFidelityCrmFixeController.js